import { atom } from 'recoil';

export { currentClassAtom };

function getStoredCurrentClass() {
    try {
        return JSON.parse(localStorage.getItem('currentClass') || 'null');
    } catch {
        localStorage.removeItem('currentClass');
        return null;
    }
}

const currentClassAtom = atom({
    key: 'currentclass',
    default: getStoredCurrentClass()
});

